export const environment = {
  production: true,
  useMockApi: false,
  apiBaseUrl: '/api',
};
